module.exports = ".brand {\n  -ms-flex-line-pack: rigth;\n      align-content: rigth; }\n\n.align-buttons {\n  text-align: right;\n  margin-left: 9px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-horometro/master-horometro.component.scss
// module id = ./src/app/master/master-horometro/master-horometro.component.scss
// module chunks = main